import React from 'react';
import logo from './logo.png';
import './App.css';
import SEO from './components/SEO';
import { generateBreadcrumbSchema } from './utils/structuredData';

export default function About() {
  // Breadcrumb structured data
  const breadcrumbs = [
    { name: 'Home', url: '/' },
    { name: 'About Us', url: '/about' }
  ];

  return (
    <section style={{ background: '#FDF8EE', minHeight: '100vh', padding: '6vw 0 4vw 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {/* SEO Meta Tags */}
      <SEO
        title="About Taealam - Our Story and Mission"
        description="Learn about Taealam, founded by Abdulla Hilal and Sayed Mohammed to connect students with qualified teachers in Bahrain. Discover our mission to revolutionize education."
        keywords="about taealam, education platform Bahrain, online learning story, tutoring platform founders, Abdulla Hilal, Sayed Mohammed"
        canonicalUrl="/about"
        alternateUrls={{ en: '/about', ar: '/about-ar' }}
        lang="en"
        structuredData={generateBreadcrumbSchema(breadcrumbs)}
      />

      <div style={{ maxWidth: 800, width: '100%', maxWidth: '95vw', margin: '0 auto', background: '#fff', borderRadius: 24, boxShadow: '0 4px 24px #e0eaff', padding: '6vw 4vw', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img src={logo} alt="Taealam Logo" style={{ width: 70, marginBottom: 20, maxWidth: '30vw' }} />
        <h1 style={{ fontSize: '2.1rem', fontWeight: 700, color: '#0F2545', marginBottom: 12, textAlign: 'center' }}>About Us</h1>
        <p style={{ color: '#888', fontSize: '1rem', textAlign: 'center', marginBottom: 24, maxWidth: 700 }}>
          Taealam is an educational platform founded by Abdulla Hilal and co-founded by Sayed Mohammed. This idea was born from our personal struggle to find qualified and reliable teachers for the subjects we needed help with. Our experience inspired us to build a solution for students like us who are looking for the right support in their learning journey.
        </p>
        <div style={{ width: '100%', borderTop: '1.5px solid #e0eaff', margin: '24px 0' }} />
        <p style={{ color: '#232B3E', fontSize: '0.98rem', textAlign: 'center', marginBottom: 18, maxWidth: 700 }}>
          The platform connects students with teachers in a seamless and organized way. Students can view teacher profiles, check available times, and book lessons directly—ensuring a more personalized and efficient learning experience. We also make sure communication is clear and secure through a built-in chat system.
        </p>
        <p style={{ color: '#232B3E', fontSize: '0.98rem', textAlign: 'center', marginBottom: 18, maxWidth: 700 }}>
          We launched Taealam to serve our local community in Bahrain, with a special focus on building trust and quality in online education. Every teacher is reviewed carefully, and the process is designed to be simple and clear for all users.
        </p>
        <p style={{ color: '#232B3E', fontSize: '0.98rem', textAlign: 'center', marginBottom: 18, maxWidth: 700 }}>
          Our goal is to continue developing Taealam, expanding its services to the Gulf region and eventually the global market. We aim to become a trusted name in education technology, making it easier for every learner to find the right teacher anytime, anywhere.
        </p>
      </div>
    </section>
  );
} 